import { Dimensionless, Measure } from 'safe-units';
import { definePayloadPlugin, definePayloadReducer, definePayloadReviver } from '#app';

export default definePayloadPlugin(() => {
  definePayloadReducer('Measure', (value) => {
    if (Measure.isMeasure(value)) {
      // return a plain Javascript object which contains the public properties
      // of the Measure
      return {
        ...value,
        unitSystem: { ...value.unitSystem },
      };
    }
  });
  definePayloadReviver('Measure', (value) => {
    // const unitSystem = UnitSystem.from(value.unitSystem.symbols);
    // // create unit classes named after their dimension to help us re-construct measures
    // // based on their recorded dimensions
    // const units = Object.keys(value.unitSystem.symbols)
    //   .map(dimension => Measure.dimension(unitSystem, dimension));

    // a Dimensionless unit is fine for deserialisation since the unit is
    // mainly useful for type safety.
    // WARNING: Dimensionless is a measure based on the SIUnitSystem, so
    // deserialisation may fail for measures in other unit systems.
    return Measure.of(value.value, Dimensionless, value.symbol);
  });
});
